import { IProps, ReadonlyRecord } from '@bimser/core';
import { List, Record } from 'immutable';

export interface IBaseTreeData {
	key: string;
	value: string;
	label?: React.ReactNode;
	title?: React.ReactNode;
	selectable?: boolean;
	disableCheckbox?: boolean;
	disable?: boolean;
	isLeaf?: boolean;
	externalData?: any;
}

export interface ITreeData extends IBaseTreeData {
	children?: ITreeData[];
}

export interface ReadOnlyTreeData extends IBaseTreeData {
	children?: List<TreeData>;
}

export type TreeData = ReadonlyRecord<ReadOnlyTreeData>;

export const TreeDataFactory = Record<ReadOnlyTreeData>({
	key: null,
	value: null,
	label: null,
	title: null,
	selectable: null,
	disableCheckbox: null,
	disable: null,
	isLeaf: null,
	children: List(),
	externalData: null
});

export const TreeDataFactoryFromJS = (data: ITreeData) =>
	TreeDataFactory({
		key: data.key,
		value: data.value,
		label: data.label,
		title: data.title,
		selectable: data.selectable,
		disableCheckbox: data.disableCheckbox,
		disable: data.disable,
		isLeaf: data.isLeaf,
		externalData: data.externalData,
		children: List(data.children?.map((value: ITreeData) => TreeDataFactoryFromJS(value)) || [])
	});

export enum treeSelectShowCheckedStrategy {
	SHOW_ALL = 'SHOW_ALL',
	SHOW_PARENT = 'SHOW_PARENT',
	SHOW_CHILD = 'SHOW_CHILD'
}

export interface ITreeSelectLoadingArgs {
	allow: boolean;
	options: Array<ITreeData>;
}

export default interface ITreeSelectProps extends IProps {
	treeData?: Array<ITreeData>;
	size?: 'middle' | 'small' | 'large';
	showSearch?: boolean;
	disabled?: boolean;
	allowClear?: boolean;
	value?: string | Array<any>;
	defaultValue?: string | Array<any>;
	multiple?: boolean;
	readOnly?: boolean;
	dropdownStyle?: React.CSSProperties;
	style?: React.CSSProperties;
	treeDefaultExpandAll?: boolean;
	treeCheckable?: boolean | React.ReactNode;
	treeDefaultExpandedKeys?: Array<string>;
	suffixIcon?: React.ReactNode;
	filterTreeNode?: (inputValue: string, treeNode: any) => boolean | boolean;
	treeNodeFilterProp?: string;
	treeNodeLabelProp?: string;
	showCheckedStrategy?: treeSelectShowCheckedStrategy;
	getPopupContainer?: (triggerNode: Element) => HTMLElement;
	onSelect?: (value: any, option?: any) => void;
	onChange?: (value: any, label?: any, extra?: any) => void;
	onSearch?: (value: any) => void;
	dropdownClassName?: string;
	virtual?: boolean;
	dropdownRender?: (menu: React.ReactElement) => React.ReactElement;
	notFoundContent?: React.ReactNode | string;
	onTreeExpand?: (expandedKeys: Array<string>) => void;
}
